var generateComponentTheme = function generateComponentTheme(_ref) {
  var colors = _ref.colors,
    spacing = _ref.spacing,
    typography = _ref.typography,
    borders = _ref.borders;
  return {
    rootBackgroundColor: colors.contrasts.white1010,
    submitBarMargin: spacing.xSmall,
    submitBarMarginBottom: spacing.small,
    fudgePointsSectionBackgroundColor: colors.contrasts.grey1111,
    fudgePointsSectionBorderRadius: borders.radiusMedium,
    fudgePointsSectionMargin: spacing.small,
    fudgePointsSectionPadding: spacing.xSmall,
    fudgePointsBoxWidth: '4.5rem',
    fudgePointsBoxPadding: spacing.xxSmall,
    fudgePointsBoxMargin: spacing.small,
    fudgePointsLabelFontSize: typography.fontSizeMedium,
    fudgePointsLabelFontWeight: typography.fontWeightBold,
    fudgeInfoFontSize: typography.fontSizeSmall,
    finalScoreWrapperMargin: spacing.small,
    finalScoreWrapperPadding: spacing.small,
    finalScoreLabelFontSize: typography.fontSizeMedium,
    finalScoreFontSize: typography.fontSizeMedium,
    finalScoreFontWeight: typography.fontWeightBold
  };
};
export default generateComponentTheme;